export default {
      id: "patch_check_fill-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.svg#patch_check_fill",
      toString: function () {
        return this.url;
      }
    }